import { type FunctionComponent, type ReactElement, useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { actionCreators } from "@App/state";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import { PresetFilterName } from "@App/types/presetFilters";

export type PresetFilterRoutesProps = {
  redirectOnMiss: ReactElement;
};

export const PresetFilterRoutes: FunctionComponent<PresetFilterRoutesProps> = ({
  redirectOnMiss,
}: PresetFilterRoutesProps) => {
  const dispatch = useDispatch();
  const { setPresetFilter, setMustUseAuthorizedGarage } = bindActionCreators(
    actionCreators,
    dispatch,
  );
  let { garageBindingType } = useParams();

  useEffect(() => {
    switch (garageBindingType) {
      case "mwb":
        setMustUseAuthorizedGarage(true);
        setPresetFilter([{ name: PresetFilterName.ITZEHOER_WITH_GARAGE_BINDING }]);
        break;
      case "owb":
        setMustUseAuthorizedGarage(false);
        setPresetFilter([{ name: PresetFilterName.ITZEHOER_WITHOUT_GARAGE_BINDING }]);
        break;
    }
  }, []);

  if (!["owb", "mwb"].includes(garageBindingType)) {
    return redirectOnMiss;
  }

  return <Outlet />;
};
